import { formatOfferEuro, PILOT_OFFER } from './offer';

/**
 * The landing FAQ: the accordion (`faq-section.tsx`) and the `FAQPage` structured data
 * (`FAQPageSchema.tsx`) both read these, so the markup always mirrors the visible questions.
 * No 'use client' here: a server component needs the values, not a client reference.
 */
export const FAQ_ITEMS = [
  { value: 'item-1', key: 'item1' },
  { value: 'item-2', key: 'item2' },
  { value: 'item-3', key: 'item3' },
  { value: 'item-4', key: 'item4' },
  { value: 'item-5', key: 'item5' },
  { value: 'item-6', key: 'item6' },
  { value: 'item-7', key: 'item7' },
  { value: 'item-8', key: 'item8' },
  { value: 'item-9', key: 'item9' },
  { value: 'item-10', key: 'item10' },
  { value: 'item-11', key: 'item11' },
  { value: 'item-12', key: 'item12' },
] as const;

/** Canteen size used by the cost example in the ROI answer. */
export const FAQ_EXAMPLE_USERS = 200;

// A type alias, not an interface, so it stays assignable to next-intl's message values.
type FaqAnswerValues = {
  perUserMonthly: string;
  exampleUsers: number;
  exampleMonthly: string;
};

/** Message values for the FAQ answers, with every price formatted for the locale. */
export function getFaqAnswerValues(locale: string): FaqAnswerValues {
  return {
    perUserMonthly: formatOfferEuro(PILOT_OFFER.perUserMonthlyEur, locale),
    exampleUsers: FAQ_EXAMPLE_USERS,
    exampleMonthly: formatOfferEuro(FAQ_EXAMPLE_USERS * PILOT_OFFER.perUserMonthlyEur, locale),
  };
}
